import React, { useState, useEffect, useRef } from "react";

export default function Bolagsverket() {
  return (
    <div>
      <center>
        <h2>Test Page</h2>
      </center>
    </div>
  );
}
